export enum NotificationAction {
  ReadAll = 0, //Dev: UI Enum value
  Read = 80,
  UnRead = 2,
  Delivered = 3,
  ActionTaken = 4,
  Created = 79,
}

export enum NotificationReadAllBit {
  All = 1,
  None = 0,
}

export enum NotificationType {
  ActionRequired = 1,
  Informational = 2,
}

export const maxBadgeCountLimit: number = 99;

export const allNotificationsPageSize: number = 20;

export enum NotificationTriggerPoint {
  Before3rdBirthday90Days = 1,
  AdditionalAssessmentApprovalNeeded = 2,
  AdditionalAssessmentApprovalNeededDuplicate = 3,
  AssessmentReportSubmittedByDOEEvaluator = 4,
  AssessmentReportSubmittedByContractedEvaluator = 5,
  IEPMeetingNotScheduledWithin30DaysAfterConsent = 6,
  ArrangeProgramAndServicesFirstCome = 7,
  NoFADWithin30DaysOfSEITAssignment = 8,
  ChildrenAwaitingPlacementSpecialClassSCIS = 9,
  ParentConsentForInitialEvaluationReceived = 10,
  AssignmentOrReassignmentOfCase = 11,
  InitialIEPMeetingDue = 12,
  AnnualMeetingDueNext30Days = 13,
  AnnualMeetingDueNext5Days = 14,
  STAC5Submitted = 15,
  StudentAddedToWaitlist = 16,
  ComplianceRunningOut30DaysAfterConsent = 17,
  AssessmentAssignedToEvaluator = 18,
  AssessmentAssignedToSecondaryAgency = 19,
  STAC5Approved = 20,
  FAD = 21,
  InitialIEPMeetingDueDuplicate = 22,
  ChildrenAwaitingPlacementSpecialClassSCISDuplicate = 23,
  AdditionalAssessmentApprovalNeededSecondDuplicate = 26,
  ComplianceRunningOutProgramAndServices = 27,
  InitialReferralSubmit = 28,
  RequestForInitialReferralSubmit = 29,
  AcceptRequestForInitialReferral = 30,
  RejectRequestForInitialReferral = 31,
  IR5DaysAfterReferralDate = 32,
  RIR10DaysAfterReferralDate = 33,
  CreationOfReevaluation = 37,
  NoticeIEPMeetingFinalized = 40,
  AssignIEPSectionToDOEUser = 43,
  IEPFinalized = 46,
  NursingReferralStatusChangesToOSHReview = 47,
  AssessmentReportApprovedByContractAgencySupervisor = 56,
  AssessmentReportRejectedByIndisciplineSupervisor = 58,
  CBSTReferralCoverLetterSent = 209,
  SpecializedSchoolAndLREFormSubmitted = 214,
  ProviderRejectsMandate = 218,
  DeclineAssignment = 220,
  MandateTerminatedWithStudentLongTermAbsent = 223,
  ProviderRetroactivelyAssignedByLocationSupervisor = 228,
  TemporaryShortTermProviderAssigned = 231,
  OutreachDeadlineRequestSubmittedToSecondaryComp3Agencies = 239,
  NoticeOfSecurementIEPTeamSent = 240,
  RequestLocationProvider = 242,
  MandateAssignedOrReassignedToContractAgency = 297,
  SubmitterSubmitsanAssistiveTechEvaluationReferral_D75OrNonD75Version = 340,
  ReviewerApprovesanAssistiveTechEvaluationReferral_D75OrNonD75Version = 341,
  ReviewerRequestsMoreInformationOnAnAssistiveTechEvaluationReferral_D75OrNonD75Version = 343

}
export const TAKE_ONE: number = 1;

export const allImpersonateUsersPageSize: number = 10;
